export default __webpack_public_path__ + "static/media/7.3ed6c949.jpeg";